export default "__VITE_ASSET__355ce52e__"